export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        role: [0, 1],
        _name: "CSidebarNavItem",
        name: "首頁",
        to: "/dashboard",
        fontIcon: "fas fa-chart-line fa-fw",
      },
      {
        role: [0, 1],
        _name: "CSidebarNavTitle",
        _children: ["主要功能"],
      },
      {
        role: [0, 1],
        _name: "CSidebarNavDropdown",
        name: "客戶資料",
        route: "/customer",
        fontIcon: "fas fa-user fa-fw",
        items: [
          {
            name: "客戶列表",
            to: "/customer/list",
          },
          {
            name: "新增客戶",
            to: "/customer/create",
          },
        ],
      },
      {
        role: [0, 1],
        _name: "CSidebarNavDropdown",
        name: "銷貨系統",
        route: "/case",
        fontIcon: "fas fa-file-invoice fa-fw",
        items: [
          {
            name: "收件總表",
            to: "/case/list",
          },
          {
            name: "新增資料",
            to: "/case/create",
          },
          {
            name: "出貨列表",
            to: "/case/invoice",
          },
        ],
      },
      {
        role: [0],
        _name: "CSidebarNavDropdown",
        name: "帳務管理",
        route: "/asset",
        fontIcon: "fas fa-money-check-alt fa-fw",
        items: [
          {
            name: "帳務列表",
            to: "/asset/list",
          },
          {
            name: "新增資料",
            to: "/asset/create",
          },
          {
            name: "帳務統計",
            to: "/asset/statistics",
          },
        ],
      },
      {
        role: [0],
        _name: "CSidebarNavTitle",
        _children: ["系統相關"],
      },
      {
        role: [0],
        _name: "CSidebarNavItem",
        name: "系統設定",
        to: "/system/setting",
        fontIcon: "fas fa-cogs fa-fw",
      },
      {
        role: [0],
        _name: "CSidebarNavItem",
        name: "項目設定",
        to: "/system/customitem",
        fontIcon: "fas fa-file-word fa-fw",
      },
    ],
  },
];
